<template>
  <div class="Component gallery-container" v-if="images.length > 0">
    <h3 v-if="galleryTitle">{{ galleryTitle }}</h3>
    <div :class="['image-wrapper', { 'loading-ok': imageLoaded }]">
      <transition name="fade" mode="out-in">
        <img
          :key="currentImage.src"
          :src="currentImage.src"
          :alt="currentImage.image_description"
          class="gallery-image"
          @load="onImageLoad"
        />
      </transition>
    </div>
    <div class="text-and-controls">
      <p class="image-text" v-if="currentImage.image_description">{{ currentImage.image_description }}</p>
      <div class="controls">
        <!-- Prev -->
        <button @click="prevImage" class="control-btn prev">
          <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="22.5" cy="22.5" r="22.5" transform="rotate(-180 22.5 22.5)"/>
            <path d="M25 16L19 22L25 28" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <!-- Pagination -->
        <span class="pagination">
          <p>{{ currentIndex + 1 }} / {{ images.length }}</p>
        </span>

        <!-- Next -->
        <button @click="nextImage" class="control-btn next">
          <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="22.5" cy="22.5" r="22.5"/>
            <path d="M20 29L26 23L20 17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getCleanPrismicImageUrl } from '../helpers/prismicHelpers';

export default {
  name: 'GalleryImage',
  props: {
    sliceData: {
      type: Object,
      required: true
    },
    prismicLang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentIndex: 0,
      imageLoaded: false
    };
  },
  computed: {
    galleryTitle() {
      return this.sliceData?.primary?.carousel_title?.[0]?.text || '';
    },
    images() {
      const items = this.sliceData?.items || [];
      return items.map(item => ({
        src: getCleanPrismicImageUrl(item.carousel_image?.url) || 'https://placehold.co/596x335',
        image_description: item?.image_description || ''
      })).filter(img => img.src);
    },
    currentImage() {
      return this.images[this.currentIndex] || { src: '', image_description: '' };
    }
  },
  methods: {
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.imageLoaded = false;
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.imageLoaded = false;
    },
    onImageLoad() {
      this.imageLoaded = true;
    }
  }
};
</script>